import { PageHeroCalloutCard, PageSectionsCalloutCardWithImageCalloutCard } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { RichTextType } from 'tinacms';
import { tinaField } from 'tinacms/dist/react';
import { calloutTypographyColors } from '../styles/themes';
import '../styles/tokens.stylex';
import { borderRadius, color, spacing } from '../styles/tokens.stylex';
import { Action, ActionButtons } from './Buttons/ActionButtons';
import { FeatureListType, IconFeatureList } from './IconFeatureList';
import { RichText } from './RichText';
import { TinaMarkdownContent } from 'tinacms/dist/rich-text';
export type CalloutCardDataType = PageSectionsCalloutCardWithImageCalloutCard | PageHeroCalloutCard;
interface CalloutCardFeatures {
  data: CalloutCardDataType;
  styles?: stylex.StyleXStyles;
}
type RichTextContentType = {
  typename: string;
  richText: TinaMarkdownContent | TinaMarkdownContent[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isFeatureList(item: any): item is FeatureListType {
  if (item?.__typename) {
    return !!item.__typename.match(/FeatureList$/);
  }
  return false;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isRichTextContent(item: any): item is RichTextContentType {
  if (item?.__typename) {
    return !!item.__typename.match(/RichTextContent$/);
  }
  return false;
}
export function CalloutCard({
  data,
  styles,
  ...props
}: CalloutCardFeatures) {
  return <div {...stylex.props([calloutTypographyColors, localStyles.calloutCard, styles])} {...props}>
      {data?.calloutContent ? data.calloutContent.map((content, i) => {
      const key = `${i}—${content?.__typename}`;
      if (isFeatureList(content)) {
        return <IconFeatureList data={content} key={key} />;
      }
      if (isRichTextContent(content)) {
        return <RichText key={key} data-tina-field={tinaField(content, 'richText')}>
                  {content?.richText}
                </RichText>;
      }
      return null;
    }) : null}
      <span className="x1t1x2f9 x1iyjqo2 xs83m0k" />
      {data?.ctaText && <RichText data-tina-field={tinaField(data, 'ctaText')}>
          {data.ctaText}
        </RichText>}
      {data?.actions && <ActionButtons actions={data.actions as Action[]} args={{
      componentName: data.__typename
    }} />}
    </div>;
}
const localStyles = {
  calloutCard: {
    kWkggS: "x68ikk1",
    kaIpWk: "x1o5z2k8",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kzQI83: "x1iyjqo2",
    kOIVth: "x16pmaob",
    k7Eaqz: "xl9nvqe",
    kmVPX3: "x1o4oh2x",
    $$css: true
  }
};